import { pyStr } from "@Sk";

export const s_add_event_handler = new pyStr("add_event_handler"),
    s_remove_event_handler = new pyStr("remove_event_handler"),
    s_set_event_handler = new pyStr("set_event_handler"),
    s_add_component = new pyStr("add_component"),
    s_remove_from_parent = new pyStr("remove_from_parent"),
    s_raise_event = new pyStr("raise_event"),
    s_parent = new pyStr("parent"),
    s_slots = new pyStr("slots"),
    s_slot = new pyStr("slot"),
    s_layout = new pyStr("layout"),
    s_item = new pyStr("item"),
    s_refresh_data_bindings = new pyStr("refresh_data_bindings"),
    s_refreshing_data_bindings = new pyStr("refreshing_data_bindings"),
    s_init = new pyStr("__init__"),
    s_new = new pyStr("__new__"),
    s_init_subclass = new pyStr("__init_subclass__"),
    s_setattr = new pyStr("__setattr__"),
    s_get_attribute = new pyStr("__getattribute__"),
    s_anvil_dom_element = new pyStr("_anvil_dom_element_"),
    s_anvil_setup_dom = new pyStr("_anvil_setup_dom_"),
    s_anvil_set_property_values = new pyStr("_anvil_set_property_values_"),
    s_anvil_update_design_name = new pyStr("_anvil_update_design_name_"),
    s_anvil_get_container_design_info = new pyStr("_anvil_get_container_design_info_"),
    s_anvil_update_layout_properties = new pyStr("_anvil_update_layout_properties_"),
    s_anvil_get_sections = new pyStr("_anvil_get_sections_"),
    s_anvil_get_section_dom_element = new pyStr("_anvil_get_section_dom_element_"),
    s_anvil_set_section_property_values = new pyStr("_anvil_set_section_property_values_"),
    s_anvil_enable_drop_mode = new pyStr("_anvil_enable_drop_mode_"),
    s_anvil_disable_drop_mode = new pyStr("_anvil_disable_drop_mode_"),
    s_set_parent = new pyStr("set_parent"),
    s_page_added = new pyStr("page_added"),
    s_page_removed = new pyStr("page_removed"),
    s_page_shown = new pyStr("page_shown"),
    s_set_data_binding_listener = new pyStr("set_data_binding_listener"),
    s_get_components = new pyStr("get_components"),
    s_anvil_events = new pyStr("_anvil_events_"),
    s_anvil_properties = new pyStr("_anvil_properties_"),
    s_anvil_get_interactions = new pyStr("_anvil_get_interactions_"),
    s_anvil_get_unset_property_values = new pyStr("_anvil_get_unset_property_values_"),
    s_name = new pyStr("name"),
    s_form = new pyStr("form"),
    s_builtin = new pyStr("builtin"),
    s_properties = new pyStr("properties"),
    s_clear = new pyStr("clear"),
    s_notify_mounted_by_parent = new pyStr("_notify_mounted_by_parent"),
    s_notify_visibility_change = new pyStr("_notify_visibility_change"),
    s_x_anvil_page_added = new pyStr("x-anvil-page-added"),
    s_x_anvil_page_removed = new pyStr("x-anvil-page-removed"),
    s_x_anvil_page_shown = new pyStr("x-anvil-page-shown"),
    s_x_anvil_page_hidden = new pyStr("x-anvil-page-hidden"),
    s_x_anvil_classic_show = new pyStr("x-anvil-classic-show"),
    s_x_anvil_classic_hide = new pyStr("x-anvil-classic-hide"),
    s_show = new pyStr("show"),
    s_hide = new pyStr("hide"),
    s_update = new pyStr("update"),
    s_setdefault = new pyStr("setdefault"),
    s__module__ = new pyStr("__module__"),
    s__name__ = new pyStr("__name__"),
    s__get__ = new pyStr("__get__");
